import { type ImageV2, type UploadCareImage } from '@ev-tech/search-modules-api';

const getUploadCareImageFocalPoint = (image: UploadCareImage): `${number}% ${number}%` | 'center' => {
  const x = image.focalPoint?.focalPointX;
  const y = image.focalPoint?.focalPointY;

  if (typeof x !== 'number' || typeof y !== 'number') {
    return 'center';
  }

  return `${x}% ${y}%`;
};

export const getObjectPosition = (image?: UploadCareImage | ImageV2): string => {
  if (!image) {
    return 'center';
  }

  if ('focalPoint' in image) {
    return getUploadCareImageFocalPoint(image);
  }

  if ('focalPointX' in image && 'focalPointY' in image) {
    return `${image.focalPointX}% ${image.focalPointY}%`;
  }

  return 'center';
};
